import React from "react";
import { Col, Row} from 'react-bootstrap';
import { ClientsTable } from "../../components/Tables";
import { useAuth } from "../../hooks/auth.hook";

function ClientsPage() {
    const {user: authUser} = useAuth();
  
    return (
      <>
        <Row className="justify-content-md-center" style={{paddingRight:"2vw", marginTop: "2vw"}}>
          <Col xs={12} className="mb-4 d-none d-sm-block">
            <ClientsTable
              type="all"
              actions={[
                {
                  type: "search",
                },
                {
                  type: "export"
                }
              ]}
              deactivateAll
              showIbNumbRow={!authUser.is_afiliate}
            />
          </Col>
        </Row>
      </>
    );
  }
  
  export default ClientsPage;
  